export default {
  "blank-shell": () => import("/vercel/path0/layouts/blankShell.vue").then(m => m.default || m),
  navigation: () => import("/vercel/path0/layouts/navigation.vue").then(m => m.default || m)
}